import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const StartIndividualBoard = ({ language, refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageSplitBoardLesson.start.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.start.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.start.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.start.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.start.explanation4"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/lessonPage_MultiBoardStart.jpeg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageSplitBoardLesson-start'}
            title={'tutorial.manageSplitBoardLesson.start.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default StartIndividualBoard;
